import { debounce, getOffsetTop } from './utils';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

document.querySelectorAll('a').forEach((link) => {
  var hashPos = link.href.indexOf('#');
  if (
    hashPos !== -1 &&
    !Object.keys(link.dataset).some(function (k) {
      return ~k.indexOf('bs');
    })
  ) {
    var id = link.href.substr(hashPos + 1);
    if (id) {
      var dest = document.getElementById(id);
      if (dest) {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          window.scrollTo({
            top: getOffsetTop(dest) - document.querySelector('.js-main-navbar').offsetHeight - 12,
            behavior: 'smooth',
          });
          // history.pushState(null, null, '#' + id);
        });
      }
    }
  }
});

const initialSroll = () => {
  var hashPos = document.location.href.indexOf('#');
  if (hashPos !== -1) {
    var id = document.location.href.substr(hashPos + 1);
    if (id) {
      var dest = document.getElementById(id);
      if (dest) {
        window.scrollTo({
          top: getOffsetTop(dest) - document.querySelector('.js-main-navbar').offsetHeight - 12,
          behavior: 'smooth',
        });
      }
    }
  }
};

window.addEventListener('load', initialSroll);
var body = document.body;
var animationDuration = 250;
var navbar = document.querySelector('.js-main-navbar');
var menu = document.querySelector('.js-mobile-menu');

document.querySelectorAll('.js-mobile-menu-button').forEach((button) => {
  // TODO: MFR - keep scroll position after removing no-scoll class

  button.addEventListener('click', (event) => {
    event.preventDefault();

    navbar.classList.add('pointer-events-none');
    menu.classList.add('pointer-events-none');
    if (!body.classList.contains('mobile-nav-open')) {
      // close
      body.classList.add('mobile-nav-open');

      menu.classList.remove('hidden');

      setTimeout(() => {
        menu.classList.remove('opacity-0');
        menu.classList.add('opacity-100');
      });
      setTimeout(() => {
        navbar.classList.remove('pointer-events-none');
        menu.classList.remove('pointer-events-none');
      }, animationDuration);
    } else {
      // open
      body.classList.remove('mobile-nav-open');

      setTimeout(() => {
        menu.classList.add('hidden');
        navbar.classList.remove('pointer-events-none');
        menu.classList.remove('pointer-events-none');
      }, animationDuration);
      menu.classList.add('opacity-0');
      menu.classList.remove('opacity-100');
    }
  });
});
